import { cache } from '@/container/apollo-client/cache';
import { DirectionTypeEnum, RecentMessageConversation, ScheduleMessageMutation } from '@/types/generated/graphql';
import { gql } from '@apollo/client';

export function cacheDeleteMessageSchedule(nodeId: string) {
  try {
    const normalizedId = cache.identify({ id: nodeId, __typename: 'MessageSchedule' });
    cache.evict({ id: normalizedId });
    cache.gc();
  } catch (error) {
    console.error('Error deleting scheduled message:', error);
  }
}

export function insertNewScheduleMessageInCache(data: ScheduleMessageMutation, channelId: string, clientId: string) {
  const newItem = data?.scheduleMessage?.data;
  if (newItem) {
    const newRef = cache.writeFragment({
      data: newItem,
      fragment: MESSAGE_SCHEDULE_FRAGMENT,
    });
    cache.modify({
      fields: {
        messageSchedules(existing = {}, { storeFieldName }) {
          const expectedFieldName = `messageSchedules:{"channelId":${channelId},"clientId":${clientId}}`;
          if (storeFieldName !== expectedFieldName) {
            return existing;
          }
          return {
            ...existing,
            data: [newRef, ...(existing?.data ?? [])],
          };
        },
      },
    });

    const recentMessageId = `RecentMessageConversation:{"client":{"id":${clientId}},"channel":{"id":${channelId}}}`;

    const recentMessage = cache.readFragment<RecentMessageConversation>({
      id: recentMessageId,
      fragment: FRAGMENT_RECENT_MESSAGE1,
    });

    if (recentMessage?.draft?.mediaCount || recentMessage?.draft?.messageContent) {
      cache.writeFragment<RecentMessageConversation>({
        id: `RecentMessageConversation:{"client":{"id":${clientId}},"channel":{"id":${channelId}}}`,
        fragment: FRAGMENT_RECENT_MESSAGE,
        data: {
          draft: {
            messageContent: null,
            mediaCount: 0,
          },
          messageConversation: {
            messageContent: '',
            direction: DirectionTypeEnum.outgoing,
          },
          hasScheduledMessages: true,
        },
      });
    } else {
      cache.writeFragment<RecentMessageConversation>({
        id: recentMessageId,
        fragment: FRAGMENT_RECENT_MESSAGE,
        data: {
          hasScheduledMessages: true,
        },
      });
    }
  }
}

const MESSAGE_SCHEDULE_FRAGMENT = gql`
  fragment MessageScheduleListItem on MessageSchedule {
    id
    scheduleAt
    messageContent
    createdAt
    failureReason
    status
    attachments {
      id
      url
      mimetype
    }
    client {
      id
      name
      profilePicture {
        id
        url
      }
      country {
        id
        flag
      }
    }
    channel {
      id
    }
  }
`;

const FRAGMENT_RECENT_MESSAGE = gql`
  fragment ScheduleRecentMessage on RecentMessageConversation {
    draft {
      mediaCount
      messageContent
    }
    messageConversation {
      direction
      messageContent
    }
    hasScheduledMessages
  }
`;

const FRAGMENT_RECENT_MESSAGE1 = gql`
  fragment DraftRecentMessage on RecentMessageConversation {
    draft {
      mediaCount
      messageContent
    }
  }
`;
